import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp, commonData } from "@/mixins/index";
export default {
  mixins: [popUp, commonData],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        login_type_id: "",
        appid: "",
        params: [],
        is_show: 1,
        pkg1: ''
      },
      params: [],
      rules: {
        login_type_id: [{
          required: true,
          message: "请选择应用",
          trigger: "blur"
        }],
        appid: [{
          required: true,
          message: "请选择登录类型",
          trigger: "blur"
        }],
        params: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        is_show: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var list, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                _context.next = 3;
                return _this.getcommonData(['appListAllData', 'appLoginTypeRes']);

              case 3:
                _this.appLoginTypeRes = _this.appLoginTypeRes.reverse();

                if (data) {
                  list = [];

                  for (key in data.params) {
                    list.push({
                      label: key,
                      value: data.params[key]
                    });
                  }

                  _this.formData = _objectSpread(_objectSpread({}, data), {}, {
                    params: list
                  });

                  _this.payTypeChange(data.login_type_id, false);
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    payTypeChange: function payTypeChange(e) {
      var isClear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!e) {
        this.formData.params = [];
        return;
      }

      if (isClear) {
        var list = this.appLoginTypeRes.length ? this.appLoginTypeRes.find(function (item) {
          return item.id == e;
        }).param_keys : [];
        this.formData.params = list ? list.map(function (i) {
          return {
            label: i,
            value: ''
          };
        }) : [];
      }
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.payTypeChange(this.formDataMake.login_type_id, false);
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, d, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 12;
                    break;
                  }

                  if (!_this2.formData.id) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return _this2.secondConfirmation();

                case 4:
                  data = JSON.parse(JSON.stringify(_this2.formData));
                  d = {};
                  data.params.forEach(function (item, index) {
                    d[item.label] = item.value;
                  });
                  data.params = JSON.stringify(d);
                  reqFn = data.id ? 'appLoginTypeConfigUpd' : 'appLoginTypeConfigAdd';

                  _this2.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                    isMustAppid: 1
                  })).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  });

                  _context2.next = 13;
                  break;

                case 12:
                  return _context2.abrupt("return", false);

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};